require('./etat-chaines.scss');

import DemandeActions from '../../../../actions/demande.actions';
import { STEPS } from '../../../../utils/routes.util';

export default class EtatChainesComponent {
  constructor() {
    this.controller = EtatChainesController;
    this.template = require('./etat-chaines.html');
  }
}

// @ngInject
class EtatChainesController {

  constructor($scope, $ngRedux) {
    this.$ngRedux = $ngRedux;
    this.$scope = $scope;
    this.data = {};
  }

  $onInit() {
    // Demande de récupération de la demande avant connexion au state
    this.$ngRedux.dispatch(DemandeActions.loadDemande(STEPS.ETAT_CHAINES));
    // Connexion au state récupérer les données modifiées
    const disconnect = this.$ngRedux.connect(
      state => {
        return {
          working: state.general.working,
          failure: state.demande.failure,
          fetching: state.demande.fetching,
          data: state.demande.data.etatChaines ? state.demande.data.etatChaines.asMutable({deep: true}) : this.data,
          typePersonne: state.demande.data.typePersonne
        };
      }
    )(this);

    // Déconnexion du state à la suppression du composant
    this.$scope.$on('$destroy', disconnect);
  }

  // Actions
  prevStep() {
    this.$ngRedux.dispatch(DemandeActions.updateEtatChaines({}, true));
  }
  nextStep(source) {
    this.data.source = source;
    this.$ngRedux.dispatch(DemandeActions.updateEtatChaines(this.data));
  }
}



// WEBPACK FOOTER //
// ./src/modules/accueil/components/etat-chaines/etat-chaines.component.js